import { Helmet } from "react-helmet";
import Layout from "../../components/Layout";
import styles from "./index.module.scss";

const NoMatch = () => {
  return (
    <Layout>
      <Helmet>
        <title>Page Not Found</title>
      </Helmet>
      <div className={styles.container}>
        The page you were looking for could not be found
      </div>
    </Layout>
  );
};

export default NoMatch;
